import type React from 'react';
import { WizardForm } from '../components/wizard/WizardForm.js';
import { useHeaderClickInterceptor } from '../hooks/useHeaderClickInterceptor.js';

export const WizardPage: React.FC = () => {
  useHeaderClickInterceptor();

  return <WizardForm />;
};
